
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/ticket_books/[productPublicId]/purchase",
      function () {
        return require("private-next-pages/[publicId]/ticket_books/[productPublicId]/purchase/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/ticket_books/[productPublicId]/purchase"])
      });
    }
  